<template>
  <div class="topic-list">
    <div class="animated fadeIn pt-10">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('topic.topic') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn bg-main border-radius-4px right" @click="createTopic"><i class="fa fa-plus"></i>&nbsp; {{$t('topic.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">

              <b-row >
                <b-col cols="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="topic">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
                <b-col cols="2">
                  <b-input-group v-bind:prepend="$t('topic.active')">
                    <b-form-select v-model="filter.active" v-bind:value="filter.active" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('topic.active')">
                    </b-form-select>
                  </b-input-group>
                </b-col>
                <b-col cols="4">
                  <b-input-group v-bind:prepend="$t('topic.display_period')" >
                    <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('topic.active')}}</th>
                    <th scope="col" :class="item.sort?'pointer':''" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" >
                      <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('topic.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('topic.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 3">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="updateStatusItem(item)" />
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" >
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="200">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100, 200, 500]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }
  .custom-control-label::before {
    border-radius: 3px !important;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import DatePicker from 'vue2-datepicker'
import cSwitch from '../../../components/Switch'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'TopicList',
  components: {
    SelectDropdown,
    DateRangePicker,
    DatePicker,
    cSwitch,
    DataTable
  },
  data: function () {
    return {
      date: [],
      statuses: [],
      filter: {
        options: [],
        selected: null,
        startAt: this.$moment().format('YYYY-MM-DD'),
        endAt: this.$moment().add(3, 'months').format('YYYY-MM-DD'),
        date: [],
        active: '',
        publish: '',
        content_status: '',
        category: '',
        display_category: '',
        name: '',
        sku: '',
        field: null,
        key: null,
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'code',
            label: 'code',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'name',
            label: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'sequence',
            label: 'sequence',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'display_start',
            label: 'display_period',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              let start = this.convertUTCToClientTime(row.display_start)
              let end = this.convertUTCToClientTime(row.display_end)
              return this.$moment(start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') + ' ~ ' + this.$moment(end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
            }
          },
          // {
          //   name: 'applicable_start',
          //   label: 'applicable_period',
          //   filter: false,
          //   sort: true,
          //   render: (data, row) => {
          //     if (data == null) {
          //       return ''
          //     }
          //
          //     let start = this.convertUTCToClientTime(row.applicable_start)
          //     let end = this.convertUTCToClientTime(row.applicable_end)
          //     return this.$moment(start, 'YYYY-MM-DD HH:mm:ss').format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() : 'DD-MM-YYYY') + ' ~ ' + this.$moment(end, 'YYYY-MM-DD HH:mm:ss').format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() : 'DD-MM-YYYY')
          //   }
          // }
        ],
        sort: {
          field: 'code',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {}
    }
  },
  methods: {
    /**
     * convert date format then refresh data when date range update
     * @param val
     */
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.refreshData()
    },
    /**
     * update active by uuid
     * @param uuid and active
     */
    updateStatusItem (item) {
      let params = {
        uuid: item.uuid,
        active: item.active
      }
      this.axios.campaign.updateTopicStatus(params, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      }, function (response) {
        vm.refreshData()
      })
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }

      // get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type,
        start: this.filter.startAt,
        end: this.filter.endAt
      }

      if (this.filter.category != '') {
        _data['category_id'] = this.filter.category
      }
      if (this.filter.display_category != '') {
        _data['display_category_id'] = this.filter.display_category
      }

      if (String(this.filter.active) != '') {
        _data['active'] = this.filter.active
      }

      if (String(this.filter.publish) != '') {
        _data['publish'] = this.filter.publish
      }

      if (this.filter.content_status != '') {
        _data['content_status'] = this.filter.content_status
      }

      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      // process to send via get method
      let params = ''
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      // remove tail
      params = params.slice(0, -1)

      vm.axios.campaign.getTopicList(params, {
        cancelToken: new CancelToken(function executor (c) {
          cancel = c
        })
      }, function (response) {
        vm.dataTable.items = response.data.data.items
        vm.dataTable.total = response.data.data.pagination.total
        this.$forceUpdate()
      })
    },
    /**
     * move to detail page by uuid
     * @param uuid
     */
    editItem (uuid) {
      this.$router.push({name: 'topic_edit', params: { uuid: uuid }})
    },
    createTopic () {
      this.$router.push({name: 'topic_create', params: { uuid: 'create' }})
    }
  },
  created: function () {
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()

    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name
      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }
    let langs = vm.$store.getters.languages
    for (let l in langs) {
      vm.statuses[langs[l]] = [
        {text: vm.$t('common.all', langs[l]), value: ''},
        {text: vm.$t('common.active', langs[l]), value: '1'},
        {text: vm.$t('common.inactive', langs[l]), value: '0'}
      ]
    }

    vm.$Progress.start()
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.active': function (val) {
      vm.refreshData()
    }
  },
  computed : {
    date_locale : function () {
      let format = this.format_date_range_locale()
      if(this.$refs.drange){
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges : function () {
      return this.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/topic/List.vue